import {reducerFactory} from '../../lib/asyncUtil'
import {PASSWORDS} from '../actionTypes'

export default reducerFactory(PASSWORDS)
